import { render, staticRenderFns } from "./invoice-fee.vue?vue&type=template&id=55b20c73&scoped=true&"
import script from "./invoice-fee.vue?vue&type=script&lang=js&"
export * from "./invoice-fee.vue?vue&type=script&lang=js&"
import style0 from "./invoice-fee.vue?vue&type=style&index=0&id=55b20c73&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b20c73",
  null
  
)

export default component.exports